/**
 * Interface for units parameter type descriptors. These affect the behavior of the parameter card appearance on the Configurator.
 */
interface IUnitsTypeDescriptor {
    [unitName: string]: {
        min?: number;
        max?: number;
        default?: number;
        decimals?: number;
        largeStep?: number;
        smallStep?: number;
        valueLabel?: string;
        proportional?: boolean;
        weight?: boolean;
    }
}

export default IUnitsTypeDescriptor;
